import React from 'react';
import { WorkbookState } from 'types';
import PdfViewer from './PdfViewer';

type Props = {
  workbook: WorkbookState;
  currentPage: number;
  fingerprint?: string | null;
};

const DoublePageViewer = ({ workbook, currentPage, fingerprint }: Props) => {
  const isPortrait = workbook.orientation === 'portrait';

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: isPortrait ? 'row' : 'column',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
        height: '100%'
      }}
    >
      <PdfViewer
        currentPage={currentPage}
        workbook={workbook}
        fingerprint={fingerprint}
        isTwoPages={true}
      />
    </div>
  );
};

export default DoublePageViewer;
